import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    user: null
}

const authSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setUser: (state, action) => {state.user = action.payload.user}
        // setUserOut: (state, action) => {state.user = action.payload.user}
    }
});

export const { setUser } = authSlice.actions

export const selectUser = state => state.user

export default authSlice.reducer